import React from "react";
import NotFoudImg from "./../../assets/img/banner-section.png";
import Seo from "../../shared/seo/Seo";
import { copy, currentLang } from "../../shared/seo/links";

export default function NotFound() {
  return (
    <center style={{ marginRight: "20px", marginLeft: "20px" }}>
      <Seo noindex title={copy.page(currentLang(), "notFound").title} />
      <img
        style={{
          margin: "20px",
        }}
        src={NotFoudImg}
        width={"300px"}
      />
      <h1>404 NOT FOUND</h1>
      <p>I see you found our secret page </p>
      <br></br>
      <br></br>
      <br></br>
    </center>
  );
}
